<template>
  <v-container>
    <landing-create :content="content"></landing-create>
    <protocol-number-form
      :onSubmit="onSubmit"
      :isLoading="isLoading"
    ></protocol-number-form>
  </v-container>
</template>

<script>
import LandingCreate from '../../../components/layouts/LandingCreate.vue';
import ProtocolNumberForm from './ProtocolNumberForm.vue';
import services from '../../../services';
import utilities from '../../../utilities';

const { medicalRegistry } = services;
const { protocolNumberService } = medicalRegistry;
const { ErrorMessageUtil } = utilities;

export default {
  name: 'ProtocolNumberCreate',
  components: {
    ProtocolNumberForm,
    LandingCreate,
  },
  data: () => ({
    isLoading: false,
    content: {
      pageTitle: 'Project Code Create',
      enableBackButton: true,
    },
  }),
  methods: {
    async onSubmit(data) {
      try {
        const protocolNumber = await protocolNumberService.create({ protocolNumber: data });
        this.isLoading = true;
        const { _id } = protocolNumber;
        if (data.otherDocuments) {
          const formData = new FormData();
          formData.append('attachment', data.otherDocuments[0]);
          await protocolNumberService.upload({ id: _id, formData });
        }
        this.isLoading = false;
        this.$snackbar.showOk({ text: 'Successfully created project number!' });
        this.$router.push({ name: 'protocol-number.list' });
      } catch (e) {
        const error = e.response.data;
        this.$snackbar.showBad({
          text: ErrorMessageUtil.transform(error),
        });
      }
    },
  },
};
</script>
